import React, { useState } from "react";
import { FaSearch } from "react-icons/fa";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ApprovedConsultants from "../../components/auth/Consultants/ApprovedConsultants";
import NewlyAppliedConsultants from "../../components/auth/Consultants/NewlyAppliedConsultants";
import IncativeConsultants from "../../components/auth/Consultants/IncativeConsultants";
import AddConsultant from "../../components/Modals/AddConsultantModal";
import ViewModal from "../../components/Modals/ViewModal";
import ConsultantEnquiries from "../../components/auth/Consultants/ConsultantEnquiries";

const Consultants = () => {
  const [activeTab, setActiveTab] = useState("Enquiries");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const itemsPerPage = 6;

  const handleInputChange = (e) => {
    setQuery(e.target.value);
    setPage(1);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setPage(1);
    setQuery("");
  };

  const handleDataChange = (pages, items) => {
    setTotalPages(pages);
    setTotalItems(items);
  };

  const renderTabContent = () => {
    const commonProps = {
      query,
      page,
      itemsPerPage,
      onDataChange: handleDataChange,
    };

    switch (activeTab) {
      case "Enquiries":
        return <ConsultantEnquiries {...commonProps} />;
      case "Newly Added":
        return <NewlyAppliedConsultants {...commonProps} />;
      case "Approved":
        return <ApprovedConsultants {...commonProps} />;
      case "Inactive":
        return <IncativeConsultants {...commonProps} />;
      default:
        return null;
    }
  };

  return (
    <div className="w-full">
      {/* Header Section */}
      <div className="py-12 px-4 sm:px-6">
        <ViewModal />
        <div className="flex justify-between flex-col md:flex-row gap-4">
          <h1 className="text-primaryColor text-[22px] sm:text-[25px] md:text-3xl font-bold">
            Consultants
          </h1>

          {/* Search/Add */}
          <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto">
            {/* Search Bar */}
            <div className="searchBar relative items-center w-full md:w-64">
              <input
                type="text"
                placeholder="Search..."
                value={query}
                onChange={handleInputChange}
                className="pl-4 pr-10 py-2 w-full border-2 border-primaryColor rounded-lg"
              />
              <span className="absolute w-10 h-10 right-0 top-0 bottom-0 m-auto flex items-center justify-center rounded-r-md bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] p-2">
                <FaSearch size={18} className="text-white" />
              </span>
            </div>

            {/* Add Button */}
            {activeTab !== "Enquiries" && (
              <div className="w-full md:w-auto">
                <button
                  onClick={() => setShowModal(true)}
                  className="w-full md:w-auto flex justify-center items-center pl-4 pr-4 py-2 h-11 border-2 bg-gradient-to-r from-[#0070a8] to-[#023955] hover:from-[#1e8cbf] hover:to-[#1674a3] text-white rounded-lg"
                >
                  + Add New
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="px-4 sm:px-6">
        <div className="border-b tracking-wide justify-center">
          <div className="flex justify-start sm:justify-center overflow-x-auto no-scrollbar">
            <div className="flex w-max">
              {["Enquiries", "Newly Added", "Approved", "Inactive"].map(
                (tab) => (
                  <button
                    key={tab}
                    onClick={() => handleTabChange(tab)}
                    className={`px-4 sm:px-6 py-3 text-sm font-medium border-b-2 whitespace-nowrap ${
                      activeTab === tab
                        ? "border-primaryColor text-primaryColor bg-purple-50"
                        : "border-transparent text-gray-500 hover:text-gray-700"
                    }`}
                  >
                    {tab}
                  </button>
                )
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Tab Content */}
      <div className="overflow-x-auto mt-4 px-4">{renderTabContent()}</div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex flex-col sm:flex-row justify-center items-center gap-2 my-6 px-4">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              shape="rounded"
              color="primary"
            />
          </Stack>
          <div className="text-sm text-gray-600">
            Showing {Math.min((page - 1) * itemsPerPage + 1, totalItems)} to{" "}
            {Math.min(page * itemsPerPage, totalItems)} of {totalItems} results
          </div>
        </div>
      )}

      {/* AddConsultant Modal */}
      {showModal && <AddConsultant onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Consultants;
